// extracted by mini-css-extract-plugin
export default {"title":"f_m","chart-navigation":"f_n","chart-navigation__left":"f_p","chart-navigation__right":"f_q"};